export const repairAreas = {
  Front: 'Front',
  Centre: 'Centre',
  Rear: 'Rear',
  TrimGlass: 'Trim/Glass'
}

export const repairSections = {
  //front
  LeftFrontLamps: 'LeftFrontLamps',
  FrontBumper: 'FrontBumper',
  RightFrontLamps: 'RightFrontLamps',
  LeftFrontGuard: 'LeftFrontGuard',
  Bonnet: 'Bonnet',
  RightFrontGuard: 'RightFrontGuard',
  LeftFrontDoor: 'LeftFrontDoor',
  RightFrontDoor: 'RightFrontDoor',

  //centre
  LeftCantRail: 'LeftCantRail',
  RightCantRail: 'RightCantRail',
  Turret: 'Turret',

  //rear
  LeftRearDoor: 'LeftRearDoor',
  RightRearDoor: 'RightRearDoor',
  LeftQuarterPanel: 'LeftQuarterPanel',
  Bootlid: 'Bootlid',
  RightQuarterPanel: 'RightQuarterPanel',
  LeftRearLamps: 'LeftRearLamps',
  RearBumper: 'RearBumper',
  RightRearLamps: 'RightRearLamps',

  //trim/glass
  FrontWindscreen: 'FrontWindscreen',
  RearWindscreen: 'RearWindscreen'
}

export const repairAreaGroupingData = {
  front: {
    sortOrder: 1,
    title: 'Front',
    area: repairAreas.Front,
    items: [
      { partName: 'Left Front Lamp', partId: 'LFL', sortOrder: 3 },
      { partName: 'Front Bumper Bar', partId: 'FB', sortOrder: 2 },
      { partName: 'Grille', partId: 'G', sortOrder: 1 },
      { partName: 'Right Front Lamp', partId: 'RFL', sortOrder: 4 },
      { partName: 'Left Front Guard', partId: 'LFG', sortOrder: 5 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 },
      { partName: 'Air Conditioning', partId: 'AC', sortOrder: 35 },
      { partName: 'Bonnet', partId: 'B', sortOrder: 7 },
      { partName: 'Chassis Assembly', partId: 'FC', sortOrder: 41 },
      { partName: 'Front Apron', partId: 'FP', sortOrder: 8 },
      { partName: 'Front Chassis', partId: 'CF', sortOrder: 40 },
      { partName: 'Radiator', partId: 'RA', sortOrder: 36 },
      { partName: 'Radiator Support', partId: 'RS', sortOrder: 26 },
      { partName: 'Engine', partId: 'E', sortOrder: 38 },
      { partName: 'Engine Bay Parts', partId: 'EBH', sortOrder: 37 },
      { partName: 'Front Suspension, Steering & Wheels', partId: 'FM', sortOrder: 42 },
      { partName: 'Right Front Guard', partId: 'RFG', sortOrder: 6 },
      { partName: 'Left Front Door', partId: 'LFD', sortOrder: 25 },
      { partName: 'Left Front Pillar', partId: 'LFH', sortOrder: 34 },
      { partName: 'Left Sill Panel', partId: 'LSP', sortOrder: 24 },
      { partName: 'Left Body Side', partId: 'LBP', sortOrder: 34 },
      { partName: 'Right Front Door', partId: 'RFD', sortOrder: 9 },
      { partName: 'Right Front Pillar', partId: 'RFH', sortOrder: 28 },
      { partName: 'Right Sill Panel', partId: 'RSP', sortOrder: 10 },
      { partName: 'Right Body Side', partId: 'RBP', sortOrder: 35 }
    ],
    partIds: ['LFL', 'FB', 'G', 'RFL', 'LFG', 'B', 'AC', 'FC', 'FP', 'CF', 'RA', 'RS', 'RFG', 'LFD', 'LFH', 'LSP', 'LBP', 'RFD', 'RFH', 'RSP', 'RBP']
  },

  centre: {
    sortOrder: 2,
    title: 'Centre',
    area: repairAreas.Centre,
    items: [
      { partName: 'Antenna', partId: 'AE', sortOrder: 20 },
      { partName: 'Floor Panel', partId: 'FPAN', sortOrder: 30 },
      { partName: 'Left Cant Rail', partId: 'LCR', sortOrder: 50 },
      { partName: 'Right Cant Rail', partId: 'RCR', sortOrder: 49 },
      { partName: 'Turret', partId: 'T', sortOrder: 19 },
      { partName: 'Interior Trims', partId: 'I', sortOrder: 22 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 },
      { partName: 'Left Sill Panel', partId: 'LSP', sortOrder: 24 },
      { partName: 'Left Centre Pillar', partId: 'LCP', sortOrder: 33 },
      { partName: 'Left Body Side', partId: 'LBP', sortOrder: 34 },
      { partName: 'Right Sill Panel', partId: 'RSP', sortOrder: 10 },
      { partName: 'Right Centre Pillar', partId: 'RCP', sortOrder: 29 },
      { partName: 'Right Body Side', partId: 'RBP', sortOrder: 35 },
      { partName: 'Dash & Glove Box', partId: 'D', sortOrder: 21 }
    ],
    partIds: ['AE', 'FPAN', 'LCR', 'RCR', 'T', 'I', 'OL', 'LSP', 'LCP', 'LBP', 'RSP', 'RCP', 'RBP', 'D']
  },

  rear: {
    sortOrder: 3,
    title: 'Rear',
    area: repairAreas.Rear,
    items: [
      { partName: 'Left Sill Panel', partId: 'LSP', sortOrder: 24 },
      { partName: 'Left Centre Pillar', partId: 'LCP', sortOrder: 33 },
      { partName: 'Left Rear Door', partId: 'LRD', sortOrder: 23 },
      { partName: 'Left Body Side', partId: 'LBP', sortOrder: 34 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 },
      { partName: 'Right Sill Panel', partId: 'RSP', sortOrder: 10 },
      { partName: 'Right Centre Pillar', partId: 'RCP', sortOrder: 29 },
      { partName: 'Right Rear Door', partId: 'RRD', sortOrder: 11 },
      { partName: 'Right Body Side', partId: 'RBP', sortOrder: 35 },
      { partName: 'Left Quarter Panel', partId: 'LQP', sortOrder: 22 },
      { partName: 'Rear Suspension, Tank & Wheels', partId: 'RM', sortOrder: 43 },
      { partName: 'Beaver Panel', partId: 'BP', sortOrder: 32 },
      { partName: 'Boot Floor', partId: 'BF', sortOrder: 31 },
      { partName: 'Boot Lid', partId: 'BL', sortOrder: 17 },
      { partName: 'Tail Gate', partId: 'TG', sortOrder: 18 },
      { partName: 'Exhaust', partId: 'EXH', sortOrder: 39 },
      { partName: 'Fuel Tank', partId: 'FT', sortOrder: 51 },
      { partName: 'Rear Quarter Panel', partId: 'RQP', sortOrder: 12 },
      { partName: 'Rear Lamp', partId: 'RL', sortOrder: 14 },
      { partName: 'Rear Bumper Bar', partId: 'RB', sortOrder: 15 },
      { partName: 'Rear License Plate', partId: 'RNP', sortOrder: 16 }
    ],
    partIds: ['LSP', 'LCP', 'LRD', 'LBP', 'OL', 'RSP', 'RCP', 'RRD', 'RBP', 'RM', 'BP', 'BF', 'BL', 'TG', 'RQP', 'RL', 'RB', 'RNP']
  },

  trimGlass: {
    sortOrder: 4,
    title: 'Trim/Glass',
    area: repairAreas.TrimGlass,
    items: [
      { partName: 'Front Windscreen', partId: 'FW', sortOrder: 44 },
      { partName: 'Plenum & Firewall', partId: 'SP', sortOrder: 27 },
      { partName: 'Rear Windscreen', partId: 'RW', sortOrder: 45 }
    ],
    partIds: ['FW', 'SP', 'RW']
  }
}

export const sectionToAreaMapping = {
  // Front area sections
  'LeftFrontLamps': { //F1
    area: 'Front',
    section: repairSections.LeftFrontLamps,
    items: [
      { partName: 'Left Front Lamp', partId: 'LFL', sortOrder: 3 }
    ]
  },
  'FrontBumper': { //F2
    area: 'Front',
    section: repairSections.FrontBumper,
    items: [
      { partName: 'Front Bumper Bar', partId: 'FB', sortOrder: 2 },
      { partName: 'Grille', partId: 'G', sortOrder: 1 }
    ]
  },
  'RightFrontLamps': { //F3
    area: 'Front',
    section: repairSections.RightFrontLamps,
    items: [
      { partName: 'Right Front Lamp', partId: 'RFL', sortOrder: 4 }
    ]
  },
  'LeftFrontGuard': { //F4
    area: 'Front',
    section: repairSections.LeftFrontGuard,
    items: [
      { partName: 'Left Front Guard', partId: 'LFG', sortOrder: 5 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 }
    ]
  },
  'Bonnet': { //F5
    area: 'Front',
    section: repairSections.Bonnet,
    items: [
      { partName: 'Air Conditioning', partId: 'AC', sortOrder: 35 },
      { partName: 'Bonnet', partId: 'B', sortOrder: 7 },
      { partName: 'Chassis Assembly', partId: 'FC', sortOrder: 41 },
      { partName: 'Front Apron', partId: 'FP', sortOrder: 8 },
      { partName: 'Front Chassis', partId: 'CF', sortOrder: 40 },
      { partName: 'Radiator', partId: 'RA', sortOrder: 36 },
      { partName: 'Radiator Support', partId: 'RS', sortOrder: 26 },
      { partName: 'Engine', partId: 'E', sortOrder: 38 },
      { partName: 'Engine Bay Parts', partId: 'EBH', sortOrder: 37 },
      { partName: 'Front Suspension, Steering & Wheels', partId: 'FM', sortOrder: 42 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 }
    ]
  },
  'RightFrontGuard': { //F6
    area: 'Front',
    section: repairSections.RightFrontGuard,
    items: [
      { partName: 'Right Front Guard', partId: 'RFG', sortOrder: 6 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 }
    ]
  },
  'LeftFrontDoor': { //F7
    area: 'Front',
    section: repairSections.LeftFrontDoor,
    items: [
      { partName: 'Left Front Door', partId: 'LFD', sortOrder: 25 },
      { partName: 'Left Front Pillar', partId: 'LFH', sortOrder: 34 },
      { partName: 'Left Sill Panel', partId: 'LSP', sortOrder: 24 },
      { partName: 'Left Body Side', partId: 'LBP', sortOrder: 34 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 }
    ]
  },
  'RightFrontDoor': { //F8
    area: 'Front',
    section: repairSections.RightFrontDoor,
    items: [
      { partName: 'Right Front Door', partId: 'RFD', sortOrder: 9 },
      { partName: 'Right Front Pillar', partId: 'RFH', sortOrder: 28 },
      { partName: 'Right Sill Panel', partId: 'RSP', sortOrder: 10 },
      { partName: 'Right Body Side', partId: 'RBP', sortOrder: 35 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 }
    ]
  },

  // Centre area sections
  'Turret': { //C1
    area: 'Centre',
    section: repairSections.Turret,
    items: [
      { partName: 'Antenna', partId: 'AE', sortOrder: 20 },
      { partName: 'Floor Panel', partId: 'FPAN', sortOrder: 30 },
      { partName: 'Left Cant Rail', partId: 'LCR', sortOrder: 50 },
      { partName: 'Right Cant Rail', partId: 'RCR', sortOrder: 49 },
      { partName: 'Turret', partId: 'T', sortOrder: 19 },
      { partName: 'Dash & Glove Box', partId: 'D', sortOrder: 21 },
      { partName: 'Interior Trims', partId: 'I', sortOrder: 22 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 }
    ]
  },
  'LeftCantRail': { //C2
    area: 'Centre',
    section: repairSections.LeftCantRail,
    items: [
      { partName: 'Left Sill Panel', partId: 'LSP', sortOrder: 24 },
      { partName: 'Left Centre Pillar', partId: 'LCP', sortOrder: 33 },
      { partName: 'Left Body Side', partId: 'LBP', sortOrder: 34 }
    ]
  },
  'RightCantRail': { //C3
    area: 'Centre',
    section: repairSections.RightCantRail,
    items: [
      { partName: 'Right Sill Panel', partId: 'RSP', sortOrder: 10 },
      { partName: 'Right Centre Pillar', partId: 'RCP', sortOrder: 29 },
      { partName: 'Right Body Side', partId: 'RBP', sortOrder: 35 }
    ]
  },

  // Rear area sections
  'LeftRearDoor': { //R1
    area: 'Rear',
    section: repairSections.LeftRearDoor,
    items: [
      { partName: 'Left Sill Panel', partId: 'LSP', sortOrder: 24 },
      { partName: 'Left Centre Pillar', partId: 'LCP', sortOrder: 33 },
      { partName: 'Left Rear Door', partId: 'LRD', sortOrder: 23 },
      { partName: 'Left Body Side', partId: 'LBP', sortOrder: 34 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 }
    ]
  },
  'RightRearDoor': { //R2
    area: 'Rear',
    section: repairSections.RightRearDoor,
    items: [
      { partName: 'Right Sill Panel', partId: 'RSP', sortOrder: 10 },
      { partName: 'Right Centre Pillar', partId: 'RCP', sortOrder: 29 },
      { partName: 'Right Rear Door', partId: 'RRD', sortOrder: 11 },
      { partName: 'Right Body Side', partId: 'RBP', sortOrder: 35 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 }
    ]
  },
  'LeftQuarterPanel': { //R3
    area: 'Rear',
    section: repairSections.LeftQuarterPanel,
    items: [
      { partName: 'Left Quarter Panel', partId: 'LQP', sortOrder: 22 },
      { partName: 'Left Body Side', partId: 'LBP', sortOrder: 34 },
      { partName: 'Rear Suspension, Tank & Wheels', partId: 'RM', sortOrder: 43 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 }
    ]
  },
  'Bootlid': { //R4
    area: 'Rear',
    section: repairSections.Bootlid,
    items: [
      { partName: 'Beaver Panel', partId: 'BP', sortOrder: 32 },
      { partName: 'Boot Floor', partId: 'BF', sortOrder: 31 },
      { partName: 'Boot Lid', partId: 'BL', sortOrder: 17 },
      { partName: 'Tail Gate', partId: 'TG', sortOrder: 18 },
      { partName: 'Exhaust', partId: 'EXH', sortOrder: 39 },
      { partName: 'Fuel Tank', partId: 'FT', sortOrder: 51 },
      { partName: 'Rear Suspension, Tank & Wheels', partId: 'RM', sortOrder: 43 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 }
    ]
  },
  'RightQuarterPanel': { //R5
    area: 'Rear',
    section: repairSections.RightQuarterPanel,
    items: [
      { partName: 'Rear Quarter Panel', partId: 'RQP', sortOrder: 12 },
      { partName: 'Right Body Side', partId: 'RBP', sortOrder: 35 },
      { partName: 'Rear Suspension, Tank & Wheels', partId: 'RM', sortOrder: 43 },
      { partName: 'Decal', partId: 'OL', sortOrder: 48 }
    ]
  },
  'LeftRearLamps': { //R6
    area: 'Rear',
    section: repairSections.LeftRearLamps,
    items: [
      { partName: 'Rear Lamp', partId: 'RL', sortOrder: 14 }
    ]
  },
  'RearBumper': { //R7
    area: 'Rear',
    section: repairSections.RearBumper,
    items: [
      { partName: 'Rear Bumper Bar', partId: 'RB', sortOrder: 15 },
      { partName: 'Rear License Plate', partId: 'RNP', sortOrder: 16 }
    ]
  },
  'RightRearLamps': { //R8
    area: 'Rear',
    section: repairSections.RightRearLamps,
    items: [
      { partName: 'Rear Lamp', partId: 'RL', sortOrder: 14 }
    ]
  },

  // Trim/Glass area sections
  'FrontWindscreen': { //T1
    area: 'Trim/Glass',
    section: repairSections.FrontWindscreen,
    items: [
      { partName: 'Front Windscreen', partId: 'FW', sortOrder: 44 },
      { partName: 'Plenum & Firewall', partId: 'SP', sortOrder: 27 }
    ]
  },
  'RearWindscreen': { //T2
    area: 'Trim/Glass',
    section: repairSections.RearWindscreen,
    items: [
      { partName: 'Rear Windscreen', partId: 'RW', sortOrder: 45 }
    ]
  }
}

// Derive partIds from items so the two can't drift. They previously did: several codes
// (OL, E, EBH, FM, LQP, EXH, FT) were in items but missing from partIds, which made
// area lookups resolve them to 'Other'.
Object.values(repairAreaGroupingData).forEach((areaData) => {
  areaData.partIds = [...new Set(areaData.items.map((item) => item.partId))]
})

export const getPartsByArea = (area) => {
  const areaKey = area.toLowerCase().replace('/', '').replace(' ', '')
  return repairAreaGroupingData[areaKey] || null
}

export const getAllRepairAreas = () => {
  return Object.values(repairAreaGroupingData).sort((a, b) => a.sortOrder - b.sortOrder)
}

export const mapPartIdToSection = (partId) => {
  for (const [sectionName, sectionData] of Object.entries(sectionToAreaMapping)) {
    if (sectionData.items && sectionData.items.some(item => item.partId === partId)) {
      return sectionName
    }
  }
  return null
}

/**
 * VehicleButterflySelector selection items -> flat butterfly codes, for screens that
 * only need a `butterflyCode` filter value.
 *
 * The selector reports every part of every displayed area, checked or not, so filtering
 * on `selected` is required - otherwise touching one part filters by its whole area.
 * Codes are area-scoped in the selector (LSP, RSP, LBP, OL, LCP, RCP, RM appear in more
 * than one area, and both rear-lamp sections share RL), so the Set dedupe is required
 * too: the codes end up in a comma-joined varchar parameter where duplicates only waste
 * length.
 */
export const selectionItemsToCodes = (items) =>
  [...new Set((items || []).filter(item => item.selected).map(item => item.partId))]
